<template>
  <a
    class="ss__coCreaionItem__card__wrapper"
    :href="item.url"
    :target="item.blank ? '_blank' : '_self'">
    <div class="ss__coCreaionItem__card">
      <div class="ss__coCreaionItem__image__wrapper">
        <img :src="$formatImageSrc(item?.image, { w: 568, h: 424 })"/>
      </div>
      <div class="ss__coCreaionItem__info__wrapper">
        <div class="ss__coCreaionItem__title text_ellipsis">{{ item?.name }}</div>
        <div class="ss__coCreaionItem__desc text_ellipsis">{{ item?.description }}</div>
        <div class="ss__coCreaionItem__info__footer">
          <SsAvatar
            v-if="item?.initiator"
            :src="$formatImageSrc(item?.initiator?.avatar, { w: 32, h: 32 })"
            class="comp__SsAvatar"
          />
          <span
            class="initiator text_ellipsis"
            v-if="item?.initiator">
            {{ item?.initiator?.nickname }}
          </span>
          <span class="action">发起</span>
          <hr v-if="item?.participationCount"/>
          <span v-if="item?.participationCount" class="participationCount">
            {{ item?.participationCount }} 派友参与
          </span>
        </div>
      </div>
      <div
        :class="[
          'ss__coCreaionItem__footer',
          { 'ss__coCreaionItem__footer--onCrowdfunding': latest?.onCrowdfunding },
          { 'ss__coCreaionItem__footer--onSale': latest?.onSale },
          { 'ss__coCreaionItem__footer--yipai': latest?.isYipai }
        ]"
        :style="{'--progress': `${progress}%`}">
        <template v-if="latest?.onCrowdfunding">
          <div class="onCrowdfunding">
            <span>众筹已完成 {{ `${progress}%` }}</span>
            <span>｜</span>
            <span>{{ remainingTime }}</span>
          </div>
          <CoCreationItemButton
            class="comp__CoCreationItemButton"
            :button="latest?.button"
            :arrow-visible="true"
          />
        </template>
        <template v-else-if="latest?.onSale">
          <div class="onSale">
            <span>{{ latest?.title }}</span>
            <span class="price"><strong>{{ price }}</strong>起</span>
          </div>
          <CoCreationItemButton
            class="comp__CoCreationItemButton"
            :button="latest?.button"
            :arrow-visible="true"
          />
        </template>
        <template v-else>
          <div class="ss__coCreaionItem__updates text_ellipsis">
            <span>{{ latest?.title }}</span>
          </div>
          <CoCreationItemButton
            v-if="latest?.isYipai"
            :button="latest.button"
            class="comp__CoCreationItemButton"
            :arrow-visible="true"
          />
        </template>
      </div>
    </div>
  </a>
</template>

<script>
import {
  URL_BUTTON, YIPAI_BUTTON, INTERACTION_BUTTON, BUY_BUTTON, CROWDFUNDING_BUTTON,
  CROWDFUNDING_MONETARY_TARGET, CROWDFUNDING_QUANTITY_TARGET
} from './enum'
import CoCreationItemButton from './CoCreationItemButton/index.vue'
import SsAvatar from '../SsAvatar'
export default {
  name: 'SsCoCreationItemCard',

  components: {
    SsAvatar,
    CoCreationItemButton
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      timer: null,
      remainingTime: '',
      price: '¥??',
      priceOriginal: '¥??'
    }
  },

  computed: {
    latest () {
      return this.formatProgress(this.item.updates)
    },
    isStart () {
      if (!this.latest?.onCrowdfunding) return false
      const { crowdfundingStartTime } = this.latest?.button.panel
      if (!crowdfundingStartTime) return false
      const now = parseInt(new Date() / 1000)
      return now > crowdfundingStartTime
    },
    isEnd () {
      if (!this.latest?.onCrowdfunding) return false
      const { crowdfundingEndTime } = this.latest?.button.panel
      if (!crowdfundingEndTime) return false
      const now = parseInt(new Date() / 1000)
      return now > crowdfundingEndTime
    },
    progress () {
      if (this.latest?.onCrowdfunding) {
        const button = this.latest.button
        return button.panel.crowdfundingAchievedValue / button.panel.crowdfundingGoalValue * 100
      }
      return 0
    }
  },

  methods: {
    formatProgress (t, progressIDKey = 'id') {
      return {
        id: t.id,
        title: t.title,
        description: t.description,
        content: t.content,
        date: t.date,
        banner: t.banner,
        contributors: {
          users: t.participation_users,
          total: t.participation_count
        },
        button: this.getTimelineNodeButton(t, progressIDKey),
        onSale: BUY_BUTTON.value === t.button_type,
        onCrowdfunding: CROWDFUNDING_BUTTON.value === t.button_type,
        isYipai: YIPAI_BUTTON.value === t.button_type
      }
    },
    getTimelineNodeButton (data, progressIDKey) {
      const {
        button_title: title,
        button_url: url,
        button_type: type,
        button_icon: icon,
        content,
        button_crowdfunding_goal_type: crowdfundingGoalType,
        button_crowdfunding_goal_value: crowdfundingGoalValue,
        button_crowdfunding_start_time: crowdfundingStartTime,
        button_crowdfunding_end_time: crowdfundingEndTime,
        button_crowdfunding_price: crowdfundingPrice,
        button_crowdfunding_origin_price: crowdfundingPriceOriginal,
        button_crowdfunding_sale_value: crowdfundingAchievedValue
      } = data
      switch (type) {
        case URL_BUTTON.value:
          return { title, url, icon }
        case YIPAI_BUTTON.value:
          return {
            title,
            icon,
            url: YIPAI_BUTTON.getUrl(data.button_bullet_created_at)
          }
        case INTERACTION_BUTTON.value:
          return {
            title,
            icon,
            eventHandler: () => {}
          }
        case BUY_BUTTON.value:
          return {
            title,
            icon,
            url: BUY_BUTTON.getUrl(data.button_product_booking_id),
            getProductData: BUY_BUTTON.beforeHandler.bind(this, data.button_product_booking_id)
          }
        case CROWDFUNDING_BUTTON.value:
          return {
            title,
            icon,
            url: CROWDFUNDING_BUTTON.getUrl(data.button_product_booking_id),
            panel: {
              title: [CROWDFUNDING_MONETARY_TARGET, CROWDFUNDING_QUANTITY_TARGET]
                .find(item => item.value === crowdfundingGoalType)?.label || '',
              crowdfundingGoalValue,
              crowdfundingStartTime,
              crowdfundingEndTime,
              crowdfundingPrice,
              crowdfundingPriceOriginal,
              crowdfundingAchievedValue
            }
          }
        default:
          return {
            title: content ? title || '查看详情' : '',
            icon,
            eventHandler: () => {
              if (content) {
                this.details = data
                this.visible = true
              }
            }
          }
      }
    },
    countDown () {
      if (!this.latest?.onCrowdfunding) return
      if (!this.isStart) {
        this.remainingTime = '未开始'
        return
      }
      if (this.timer) clearTimeout(this.timer)
      this.timer = null
      const { crowdfundingEndTime } = this.latest?.button.panel
      if (!crowdfundingEndTime) return ''
      const now = parseInt(new Date() / 1000)
      const time = crowdfundingEndTime - now
      if (time > 3 * 24 * 60 * 60) {
        this.remainingTime = `剩余 ${Math.ceil(time / (24 * 60 * 60))} 天`
      } else if (time <= 0) {
        this.remainingTime = '已结束'
      } else {
        const hour = Math.floor(time / 3600)
        const minute = Math.floor(time % 3600 / 60)
        const second = time % 3600 % 60
        this.timer = setTimeout(this.countDown, 1000)
        this.remainingTime = `剩余 ${this.$formatInteger(hour)}:${this.$formatInteger(minute)}:${this.$formatInteger(second)}`
      }
    },
    async fetchData () {
      if (!this.latest?.onSale || !this.latest?.button) return
      try {
        const product = await this.latest.button.getProductData()
        const { details: skus } = product || {}
        if (skus && skus.length) {
          const temp = skus.reduce((a, b) => (b.price < a.price ? b : a), skus[0])
          this.price = `¥${this.$round(temp.price / 100, 2, 'number')}`
          this.priceOriginal = `¥${this.$round(temp.origin_price / 100, 2, 'number')}`
        }
      } catch (error) {
        console.log(error)
      }
    }
  },

  mounted () {
    this.countDown()
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>
.ss__coCreaionItem__card {
  border-radius: 16px;
  overflow: hidden;
  background: var(--color-SsCoCreationItemCard-bg, var(--B1-t));
  width: var(--width-SsCoCreationItemCard, 284px);
  box-sizing: border-box;
  border: 1px solid var(--color-imageBorder, #0000000D);
  display: flex;
  flex-direction: column;
  height: 100%;
}
.ss__coCreaionItem__image__wrapper {
  width: 100%;
  height: 212px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px 16px 0 0;
  }
}
.ss__coCreaionItem__info__wrapper {
  flex: 1;
  padding: 16px;
  border-top: 1px solid var(--color-imageBorder, #0000000D);
  border-bottom: 1px solid var(--B3-t);
}
.ss__coCreaionItem__title {
  font-size: 15px;
  font-weight: 500;
  color: var(--color-SsCoCreationItemCardTitle, var(--B8-t));
}
.ss__coCreaionItem__desc {
  font-size: 13px;
  color: var(--color-SsCoCreationItemCardDesc, var(--B8-t));
  margin-top: 2px;
}
.ss__coCreaionItem__info__footer {
  font-size: 13px;
  line-height: 18px;
  color: var(--color-SsCoCreationItemCardInfoFooter, var(--B6-t));
  --size-SsAvatar: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  hr {
    margin: 0 4px;
    border: none;
    height: 12px;
    border-left: 1px solid var(--color-SsCoCreationItemCardInfoLine, var(--B4-t));
  }
  .participationCount, .action {
    white-space: nowrap;
  }
}
.ss__coCreaionItem__updates {
  font-size: 11px;
  font-weight: 500;
  color: var(--color-SsCoCreationItemCardUpdates, var(--B6-t));
}

.ss__coCreaionItem__footer--onCrowdfunding {
  border-top: 1px solid var(--B3-t);
  display: flex;
  align-items: center;
  position: relative;
  .comp__CoCreationItemButton {
    margin-left: auto;
    --color-CoCreationItemButton: var(--brand);
    --color-CoCreationItemButton-bg: transparent;
  }
  &::before {
    content: '';
    position: absolute;
    width: var(--progress);
    height: 2px;
    background: var(--brand);
    top: -2px;
    left: 0;
  }
}

.ss__coCreaionItem__footer {
  padding: 16px;
  font-size: 11px;
  font-weight: 500;
  color: var(--B6-t);
  height: 48px
  display: flex;
  align-items: center;
  padding: 0 16px;
  --text-CoCreationItemButton: 11px;
  --size-CoCreationItemButtonIcon: 12px;

  .comp__CoCreationItemButton {
    margin-left: auto;
    --color-CoCreationItemButton: var(--purple-t);
    --color-CoCreationItemButton-bg: transparent;
  }
}

.ss__coCreaionItem__footer--yipai {
  color: var(--purple-t);
  .ss__coCreaionItem__updates {
    display: inline-flex;
    align-items: center;
    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 6px;
      background: var(--purple-t);
      margin-right: 8px;
    }
  }
}

.ss__coCreaionItem__footer--onSale {
  .price {
    color: var(--red-t);
    strong {
      font-family: "Outfit-Medium";
      font-size: 17px;
      font-weight: normal;
      margin-left: 4px;
    }
  }
  .comp__CoCreationItemButton {
    --color-CoCreationItemButton: var(--red-t);
  }
}
</style>
